import './assets/styles.css';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './firebase-config'; // Ensure Firebase is initialized

const app = createApp(App);
app.use(router);
app.mount('#app');
